import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setAlert } from '../store/generalSlice';

export default function Alert({ visible, type, messages }) {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    toastBg: '',
    toastText: '',
  });

  useEffect(() => {
    let timeout;
    if (visible) {
      timeout = setTimeout(() => {
        dispatch(
          setAlert({
            visible: false,
            messages: [],
            type: '',
          })
        );
      }, 4000);
    } else {
      clearTimeout(timeout);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [dispatch, visible]);

  useEffect(() => {
    if (messages.length > 0) {
      if (type === 'error') {
        if (state.toastBg !== 'bg-danger') {
          setState({ toastBg: 'bg-danger', toastText: 'text-white' });
        }
      } else if (type === 'warning') {
        if (state.toastBg !== 'bg-warning') {
          setState({ toastBg: 'bg-warning', toastText: 'text-white' });
        }
      } else if (type === 'success') {
        if (state.toastBg !== 'bg-success') {
          setState({ toastBg: 'bg-success', toastText: 'text-white' });
        }
      } else if (type === 'info') {
        if (state.toastBg !== 'bg-info') {
          setState({ toastBg: 'bg-info', toastText: 'text-white' });
        }
      } else if (type === '' || type === null) {
        if (state.toastBg !== '') {
          setState({ toastBg: '', toastText: '' });
        }
      }
    }
  }, [messages.length, state.toastBg, type]);

  if (!visible) {
    return null;
  }

  return (
    <div className=" t-10 r-10 mt-3 d-inline-flex toastPos justify-content-center" style={{ zIndex: 9999 }}>
      <div
        id="AlertToast"
        className={`toast ${visible ? 'showing' : ''} ${state.toastBg}  `}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div className={`toast-body ${state.toastText}`}>
          {messages && (
            <>
              {messages.map((message, i) => (
                <li key={`message-${i}`} className="list-unstyled">
                  {message}
                </li>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
